import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

const norm = (s) => String(s || "").trim();

export const useClientTags = ({ search = "", limit = 200, includeUsed = true } = {}) => {
  const queryClient = useQueryClient();
  const qSearch = norm(search);
  const qLimit = Math.min(500, Math.max(1, Number(limit || 200)));
  const qIncludeUsed = includeUsed ? 1 : 0;

  const query = useQuery(
    ["client-tags", { search: qSearch, limit: qLimit, includeUsed: qIncludeUsed }],
    async () =>
      fetchData(
        `/client-tags?search=${encodeURIComponent(qSearch)}&limit=${qLimit}&includeUsed=${qIncludeUsed}`
      ),
    {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      select: (res) => {
        const raw = res?.data ?? res;
        const list = Array.isArray(raw) ? raw : [];
        return list;
      },
    }
  );

  const createMutation = useMutation(
    (payload) => fetchData("/client-tags", "POST", payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("client-tags");
      },
    }
  );

  const updateMutation = useMutation(
    ({ id, ...payload }) => fetchData(`/client-tags/${id}`, "PUT", payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("client-tags");
      },
    }
  );

  const deleteMutation = useMutation((id) => fetchData(`/client-tags/${id}`, "DELETE"), {
    onSuccess: () => {
      queryClient.invalidateQueries("client-tags");
    },
  });

  return {
    ...query,
    data: query.data || [],
    createMutation,
    updateMutation,
    deleteMutation,
  };
};

